export default "__VITE_ASSET__66bb0c69__"